// @flow
import { combineReducers } from "redux";
import mainFilters from "./mainFilters";
import byTypology from "./filtersByTypology";
import type { MainFilters } from "./mainFilters";
import type { ByTypology } from "./filtersByTypology";
import type { CombinedReducer } from "redux";
import type { Action as TypologiesAction } from "../actions/typologies";
import type { Action as FilterssAction } from "../actions/filters";
import type { Action as LanguagesesAction } from "../actions/language";

export type Action = TypologiesAction | LanguagesesAction | FilterssAction;

export type FiltersState = {
  +mainFilters: MainFilters,
  +byTypology: ByTypology
};

const filters: CombinedReducer<FiltersState, Action> = combineReducers({
  mainFilters,
  byTypology
});

export default filters;



// WEBPACK FOOTER //
// ./src/reducers/filters.js